import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import LinePanelAddIcon from 'components/Luxkit/Icons/line/LinePanelAddIcon'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import LineReturnFlightAltIcon from 'components/Luxkit/Icons/line/LineReturnFlightAltIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'

function FlightDealUSPs() {
  return <CardCarousel pageSize={3} width="75vw">
    <VerticalSpacer gap={12}>
      <LinePanelAddIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          Bundle hotels + flights
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          Easily plan and book your next trip when you bundle hotels + flights
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
    <VerticalSpacer gap={12}>
      <LinePlaneFlyIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          Your choice of airline
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          Choose from more than 500 global airlines and fly with your favourite
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
    <VerticalSpacer gap={12}>
      <LineReturnFlightAltIcon size="L" />
      <VerticalSpacer gap={4}>
        <BodyText variant="medium" weight="bold">
          Flexible flight options
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          Find one-way or return flights, across all cabin classes, and choose the best for you
        </BodyText>
      </VerticalSpacer>
    </VerticalSpacer>
  </CardCarousel>
}

export default FlightDealUSPs
